export default {
  '/': '/',
  '%': '%',
  logIn: 'Přihlásit se',
  selectedMonths: 'Vybrané měsíce',
  forSale: 'Na prodej',
  soldOut: 'Vyprodáno',
  reportCapacityActiveFilter: 'Zobrazeno 1 z 20, aplikovaný filtr: {skill}',
  countedInCompanyProfit: 'Započítáno v zisku společnosti',
  signingIn: 'Přihlašování...',
  longSignInMessage: 'Vydržte! Bezpečně vás přihlašujeme. Může to chvíli trvat.',
  total: 'Celkem',
  key: 'Klíč',
  value: 'Hodnota',
  buttons: {
    cancel: 'Zrušit',
    confirm: 'Potvrdit',
    delete: 'Smazat',
    remove: 'Odebrat',
    save: 'Uložit',
    create: 'Vytvořit',
    update: 'Aktualizovat',
    help: 'Nápověda',
    openInNewWindow: 'Otevřít v novém okně',
    actualNow: 'Označit profil jako aktuální',
    goToV2: 'Přejít na v2',
    goToV1: 'Přejít na v1',
    expandRows: 'Rozbalit řádky',
    collapseRows: 'Sbalit řádky',
    markUpToDate: 'Označit jako aktuální',
    redirectToProfile: 'Přesměrovat na profil',
    copyToClipboard: 'Zkopírovat do schránky',
    selectAll: 'Vše',
    selectNone: 'Nic',
    en: 'EN',
    cs: 'CS',
    close: 'Zavřít',
  },
  filter: {
    search: 'Vyhledat',
    searchMenu: 'Vyhledat v menu (CTRL+K)',
    yes: 'Ano',
    no: 'Ne',
  },
  toast: {
    success: 'Úspěch',
    error: 'Chyba',
    itemDidntFound: 'Položka nebyla nalezena',
    copiedToClipboard: 'Zkopírováno do schránky',
  },
  validation: {
    required: 'Hodnota je povinná',
    before: 'Hodnota je před {name}',
    after: 'Hodnota je po {name}',
    requiredShort: 'Povinné',
    number: 'Hodnota musí být číslo',
    email: 'Hodnota musí být platný e-mail',
    projectNameIsAlreadyTaken: 'Název projektu je již obsazen',
    projectAbbreviationIsAlreadyTaken: 'Zkratka projektu je již obsazena',
    emailIsAlreadyTaken: 'E-mail je již obsazen',
    phoneIsAlreadyTaken: 'Telefon je již obsazen',
    jiraIdIsAlreadyTaken: 'Jira ID je již obsazeno',
    noPermissionsForPosition: 'Nedostatečná oprávnění pro změny pozice',
    noUniqueOrganizationPosition: 'V jedné organizaci může být pouze jedna pozice',
    workTypeRequired: 'Typ práce je povinný',
    pricePerHourRequired: 'Hodinová sazba je povinná',
    pricePerHourMustBePositive: 'Hodinová sazba musí být větší nebo rovna 0',
    workedHoursRequired: 'Odpracované hodiny jsou povinné',
    workedHoursMustBePositive: 'Odpracované hodiny musí být větší než 0',
  },
  asset: {
    // eslint-disable-next-line sonarjs/no-duplicate-string
    collaboratorSearch: 'Spolupracovník',
    search: 'Hledat majetek',
    collaborator: 'Spolupracovník',
    name: 'Název',
    description: 'Popis',
    category: 'Kategorie',
    purchasePriceWithoutVat: 'Pořizovací cena (bez DPH)',
    purchaseDate: 'Datum pořízení',
    lifespan: 'Životnost (měsíce)',
    currentLessee: 'Aktuální nájemce',
    currentLesseeName: 'Aktuální nájemce',
    owner: 'Spolupracovník',
    protocolSigned: 'Protokol podepsán',
    protocols: 'Protokoly',
    protocolType: 'Typ',
    protocolHandover: 'Předávací',
    protocolReturn: 'Vrácení',
    protocolWaitingForSign: 'Čeká na podpis',
    protocolReturnWaiting: 'Vrácení čeká',
    protocolState: 'Stav',
    protocolState_WAITING_FOR_SIGN: 'Čeká na podpis',
    protocolState_SIGNED: 'Podepsán',
    protocolState_REJECTED: 'Odmítnut',
    protocolState_CANCELED: 'Zrušen',
    protocol_handover_signed: 'Předávací podepsán',
    protocol_handover_waiting: 'Předávací čeká na podpis',
    protocol_handover_rejected: 'Předávací odmítnut',
    protocol_handover_canceled: 'Předávací zrušen',
    protocol_return_signed: 'Návratový podepsán',
    protocol_return_waiting: 'Návratový čeká na podpis',
    protocol_return_rejected: 'Návratový odmítnut',
    protocol_return_canceled: 'Návratový zrušen',
    protocolDate: 'Datum',
    protocolCollaborator: 'Spolupracovník',
    protocolDocument: 'Dokument',
    protocolViewDocument: 'Zobrazit dokument',
    note: 'Poznámka',
    create: 'Přidat nový majetek',
    edit: 'Upravit majetek',
    delete: 'Smazat',
    saveSuccess: 'Majetek uložen',
    czk: 'Kč',
    assetNumber: 'Číslo majetku',
    location: 'Umístění',
    place: 'Místo',
    brand: 'Značka',
    uuid: 'UUID',
    categoryName: 'Kategorie',
    locationName: 'Umístění',
    collaboratorName: 'Spolupracovník',
    files: 'Soubory',
    fileNames: 'Soubory',
    fileUuids: 'UUID souborů',
    fileUploadError: 'Nelze uložit soubory',
    maxFileErrorMessage: 'Nelze přidat více než 10 souborů',
    maxFileSizeErrorMessage: 'Maximální velikost souboru je 30 MB',
    dropText: 'Přetáhněte soubory sem',
    updatedAt: 'Aktualizováno',
  },
  collaboratorStats: {
    namePosition: 'Jméno/Pozice',
    internal: 'Interní',
    external: 'Externí',
    title: 'Statistiky spolupracovníků',
    year: 'Rok',
    joiners: 'Příchozí členové týmu',
    leavers: 'Odchozí členové týmu',
    monthlyFluctuation: 'Míra odchodů (%)',
    quarterlyFluctuation: 'Fluktuace hrubá - kvartál (%)',
    yearlyFluctuation: 'Fluktuace hrubá - rok (%)',
    total: 'TOTAL',
    totalWithoutBoard: 'TOTAL BEZ BOARDU',
  },
  bankTransaction: {
    uuid: 'UUID',
    description: 'Popis',
    amount: 'Částka (s DPH)',
    amountWithoutVat: 'Částka (bez DPH)',
    amountLeft: 'Zbývající částka transakce',
    date: 'Datum',
    userNotes: 'Poznámky uživatele',
    authorName: 'Jméno autora',
    subjectName: 'Jméno subjektu',
    subjectBic: 'BIC subjektu',
    subjectAccountNumber: 'Číslo účtu subjektu',
    extra: 'Extra',
    checked: 'Zkontrolováno',
    companyProfitDate: 'Měsíc započtení zisku',
    minAmount: 'Částka je menší než',
    maxAmount: 'Částka je větší než',
    bankTransactionDetail: 'Detail bankovní transakce',
    accountNumber: 'Číslo účtu',
    paymentAuthor: 'Autor platby',
    author: 'Autor platby',
    deductibleVatPercent: 'Uplatnitelné DPH %',
    id: 'ID',
    comment: 'Komentář',
    orderId: 'ID objednávky',
    type: 'Typ',
    partnerNumber: 'Číslo partnera',
    extraInformation: 'Dodatečné informace',
    bankTransactionList: 'Seznam bankovních transakcí',
    constantSymbol: 'Konstantní symbol',
    lookingForBankTransactions: 'Hledání bankovních transakcí...',
    messageForPartner: 'Zpráva pro příjemce',
    partnerBankAccountNumber: 'Číslo bankovního účtu partnera',
    partnerBankBic: 'BIC banky partnera',
    partnerBankCode: 'Kód banky partnera',
    partnerBankName: 'Název banky partnera',
    partnerName: 'Jméno partnera',
    selectedBankAccount: 'Vybrat bankovní účet',
    specificSymbol: 'Specifický symbol',
    split: 'Rozdělit',
    splitTransaction: 'Rozdělená transakce',
    isTransactionSplit: 'Rozdělená transakce',
    thisAccountDoesNotAppearToContainAnyTransactionYet: 'Zdá se, že tento účet zatím neobsahuje žádné transakce',
    transactionDate: 'Datum transakce',
    userIdentification: 'Identifikace uživatele',
    variableSymbol: 'Variabilní symbol',
    selectInitialDateForSync: 'Vyberte počáteční datum pro synchronizaci',
    transactionDoesNotContainMoreDetails: 'Transakce neobsahuje další podrobnosti',
    filterBankTransactions: 'Filtrovat bankovní transakce',
    bankTransactionCostCategory: 'Kategorie nákladu',
    searchBankTransActions: 'Hledat bankovní transakce',
    selectAllBankAccounts: 'Vybrat všechny bankovní účty',
    costCategories: 'Kategorie nákladu',
    bankAccount: 'Bankovní účet',
    dateRangeFilter: 'Filtr rozsahu dat',
    transactionDateRange: 'Rozsah data transakce',
    costCategory: 'Kategorie nákladu',
    bankAccountLoadError: 'Nelze načíst bankovní účty',
    getRowsError: 'Nelze načíst bankovní transakce',
    findBankAccountIdError: 'Nelze najít ID bankovního účtu',
    findCostCategoryIdError: 'Nelze najít ID kategorie nákladu',
    transactionUpdateError: 'Při aktualizaci transakce došlo k problému',
    getBankTransactionDetailsError: 'Nelze načíst podrobnosti bankovní transakce',
    currency: 'Měna',
    companyCalculationDate: 'Datum započtení',
  },
  collaboratorSkills: {
    name: 'Jméno',
    position: 'Pozice',
    skillValuesUpdatedAt: 'Aktualizováno',
    addNewSkill: 'Přidat dovednosti',
    levels: {
      none: 'Žádná',
      low: 'Nízká',
      medium: 'Střední',
      high: 'Vysoká',
      extreme: 'Extrémní',
    },
    profileOutdatedBannerDays:
      'Nezapomeň zkontrolovat také profil spolupracovníka — poslední úprava byla před {days} dny.',
    profileOutdatedBannerNever: 'Profil tohoto spolupracovníka ještě nebyl aktualizován.',
    openProfile: 'Otevřít profil',
  },
  costCategories: {
    wages: 'Mzdy',
    outsource: 'Outsource',
    hr_internal: 'HR interní',
    hr_external: 'HR externí',
    equipment: 'Vybavení',
    infrastructure_internal: 'Infrastruktura interní',
    infrastructure_external: 'Infrastruktura externí',
    administration: 'Administrativa',
    sales: 'Obchod',
    rtsg: 'RTSG',
    other: 'Ostatní',
    office: 'Kancelář',
    vat: 'DPH',
    notCategorized: 'Nekategorizováno',
    getDataError: 'Nelze načíst data nákladových kategorií',
  },
  workLogAnalysis: {
    issuesStatistics: 'Statistika chyb výkazu práce',
    actions: 'Akce',
    fullName: 'Jméno',
    filterDates: 'Filtr dat',
    selectWorkLogIssueState: 'Vybrat stav úkolu',
    selectWorkLogIssueType: 'Vybrat typ úkolu',
    selectProject: 'Vybrat projekt',
    collaboratorSearch: 'Spolupracovník',
    ticketKey: 'Klíč',
    ticketTitle: 'Název ticketu',
    collaborator: 'Spolupracovník',
    updatedAt: 'Výkaz aktualizován',
    workedAt: 'Začátek práce',
    loggedTime: 'Vykázaný čas',
    issueType: 'Typ chyby',
    issueStatus: 'Stav chyby',
    createdAt: 'Výkaz vytvořen',
    help: {
      syncText: 'Výkazy práce se synchronizují každých 10 minut.',
      openJiraTicket: 'Jira ticket můžete otevřít kliknutím na klíč ticketu v tabulce.',
      logTimeFormats: 'Vykázaný čas: 1t = 5d, 1d = 8h, 1h = 60m',
    },
    markIssueAsResolved: 'Označit chybu jako vyřešenou',
    markIssueAsNew: 'Označit chybu jako novou',
    fetchDataError: 'Nelze načíst data tabulky',
  },
  estimateAnalysis: {
    title: 'Analýza odhadů',
    ticketKey: 'Klíč ticketu',
    md: 'MD',
    filterDateFrom: 'Datum od',
    filterDateTo: 'Datum do',
    filterDates: 'Filtr dat',
    status: 'Stav',
    resolved: 'Vyřešené',
    unresolved: 'Nevyřešené',
    selectProject: 'Vybrat projekt',
    projectStatus: 'Stav projektu',
    ticketStatus: 'Stav ticketu',
    all: 'Vše',
    active: 'Aktivní',
    inactive: 'Neaktivní',
    showOnlyActiveProjects: 'Zobrazit pouze aktivní projekty',
    selectCollaborator: 'Vybrat spolupracovníka',
    ticketsTab: 'Tickety',
    dashboardTab: 'Dashboard',
    projectName: 'Projekt',
    ticketTitle: 'Ticket',
    collaborator: 'Spolupracovník',
    resolvedAt: 'Vyřešeno',
    updatedAt: 'Aktualizováno',
    issueType: 'Typ',
    estimateMD: 'Odhad (MD)',
    loggedMD: 'Vykázáno (MD)',
    ratio: 'Poměr (%)',
    ticketCount: 'Počet ticketů',
    avgRatio: 'Průměrný poměr',
    histogramTitle: 'Distribuce odhadů vs. vykázaného času',
    ratioPercentage: 'Poměr (%)',
    byProjectTitle: 'Tikety podle projektů',
    byCollaboratorTitle: 'Tikety podle spolupracovníků',
    histogramDescription: 'Četnost tiketů dle poměru',
    noData: 'Žádná data k dispozici',
    kpi: {
      totalTickets: 'Celkem ticketů',
      totalEstimateMD: 'Celkem odhad (MD)',
      totalLoggedMD: 'Celkem vykázáno (MD)',
      weightedAverageRatio: 'Vážený průměrný poměr (%)',
    },
  },
  collaboratorCost: {
    month: 'Měsíc',
    history: 'Historie nákladů spolupracovníka',
    help: {
      buttonsOfRow: 'Tlačítka řádku',
      buttons: {
        edit: 'Upravit - upravit vybraný řádek',
        copy: 'Kopírovat - kopírovat vybraný řádek z předchozího měsíce',
      },
      valuesCopying:
        'První den každého měsíce se hodnoty pro všechny spolupracovníky kopírují z předchozího měsíce do aktuálního.',
      totalCostsPerHour:
        'Celkové náklady na hodinu = celkové mzdové náklady na hodinu + (suma provozních nákladů za měsíc / suma pracovních dní spolupracovníků na projektu za měsíc)',
      maxDppWorkloadHours: '1 FTE = 28h',
    },
    editTitle: 'Náklady spolupracovníka',
    collaborator: {
      firstName: 'Jméno',
      lastName: 'Příjmení',
      position: 'Pozice',
    },
    setFromMonth: 'Nastavit náklady od měsíce',
    setToMonth: 'Nastavit náklady do měsíce',
    wageSendingCostsPerMonth: 'Náklady na odeslání mzdy měsíčně',
    totalWageCostsPerHour: 'Celkové mzdové náklady na hodinu',
    totalCostsPerHour: 'Celkové náklady na hodinu',
    primaryLegalType: 'Primární právní forma',
    primaryLegalTypeWithNote: 'Primární právní forma (použito pro výpočet zisku projektů)',
    workloadHours: 'Hodiny úvazku',
    hppWorkloadHours: 'HPP - Hodiny úvazku',
    dppWorkloadHours: 'DPP - Hodiny úvazku',
    zlWorkloadHours: 'ZL - Hodiny úvazku',
    hppFullTimeEquivalent: 'HPP - Ekvivalent plného úvazku (FTE)',
    dppFullTimeEquivalent: 'DPP - Ekvivalent plného úvazku (FTE)',
    zlFullTimeEquivalent: 'ZL - Ekvivalent plného úvazku (FTE)',
    grossWagePerMonth: 'Hrubá mzda měsíčně',
    hppGrossWagePerMonth: 'HPP - Hrubá mzda měsíčně',
    grossWagePerHour: 'Odměna za hodinu',
    dppGrossWagePerHour: 'DPP - Odměna za hodinu',
    zlGrossWagePerHour: 'ZL - Odměna za hodinu',
    standardBonus: 'Standardní bonus',
    hppStandardBonus: 'HPP - Standardní bonus',
    dppStandardBonus: 'DPP - Standardní bonus',
    zlStandardBonus: 'ZL - Standardní bonus',
    oneTimeBonus: 'Jednorázový bonus',
    hppOneTimeBonus: 'HPP - Jednorázový bonus',
    dppOneTimeBonus: 'DPP - Jednorázový bonus',
    zlOneTimeBonus: 'ZL - Jednorázový bonus',
    vacationDayCount: 'Počet dní dovolené',
    hppVacationDayCount: 'HPP - Počet dní dovolené',
    mealVoucherCosts: 'Náklady na stravenky',
    hppMealVoucherCosts: 'HPP - Náklady na stravenky',
    filterDateMonth: 'Datum nákladů',
    edit: 'Upravit náklady na spolupracovníka',
    copy: 'Kopírovat náklady na spolupracovníka',
    previousMonthValuesNotFound: 'Hodnoty předchozího měsíce nebyly nalezeny',
    search: 'Hledat náklady na spolupracovníka',
    formIsNotValid: 'Formulář není platný',
    collaboratorPositions: 'Pozice spolupracovníka',
    getListError: 'Nelze získat seznam nákladů na spolupracovníky',
    getCollaboratorPositionsError: 'Nelze získat pozice spolupracovníka',
    fullTimeEquivalent: 'Ekvivalent plného úvazku (FTE)',
    fullTimeEquivalents: {
      FTE_1: '1',
      FTE_0_5: '0.5',
      FTE_0: '0',
    },
  },
  collaboratorWorkPlan: {
    firstName: 'Jméno',
    lastName: 'Příjmení',
    position: 'Pozice',
    saveCollaboratorWorkPlan: 'Uložit pracovní plán spolupracovníka',
    sumPlannedCountedInAverageCostsPerHour: '∑ zahrnuto v plánovaných průměrných nákladech na hodinu:',
    workDaysMD: 'Pracovní MD',
    paidVacationMD: 'MD dovolené',
    unpaidVacationMD: 'MD neplacené dovolené',
    lookingForCollaboratorWorkPlans: 'Hledání pracovních plánů spolupracovníků...',
    noCollaboratorWorkPlan: 'Žádný pracovní plán spolupracovníka...',
    countInAverageCostPerHour: 'Zahrnout do průměrných nákladů na hodinu',
    filterDateMonth: 'Datum měsíce pracovního plánu',
    workDaysSumInMD: '∑ plánovaná práce:',
    paidVacationSumInMD: '∑ plánovaná dovolená:',
    unpaidVacationSumInMD: '∑ plánovaná neplacená dovolená:',
    countableForAverageOperationCosts: '∑ započítatelných pro průměrné provozní náklady:',
    MD: 'MD',
    hour: 'h',
    successSaved: 'Hodnoty úspěšně uloženy',
    baseWorkingMD: 'Základní pracovní MD',
    plannedWorkingMD: 'Plánované pracovní MD',
    plannedVacationMD: 'Plánovaná dovolená MD',
    plannedUnpaidVacationMD: 'Plánovaná neplacená dovolená MD',
    realWorkingMD: 'Skutečné pracovní MD',
    realVacationMD: 'Skutečná dovolená MD',
    realUnpaidVacationMD: 'Skutečná neplacená dovolená MD',
    includedInProjectPlan: 'Započítat do průměrných provozních nákladů',
    setBaseWorkingMd: 'Nastavit základní pracovní dny pro všechny v aktuálním měsíci',
    baseWorkingDaysDialog: {
      title: 'Chcete nastavit základní pracovní dny?',
      text: 'Základní pracovní dny budou nastaveny pro všechny spolupracovníky ve vybraném měsíci.',
    },
    baseWorkingDaysSuccessSaved: 'Základní pracovní dny byly nastaveny pro všechny spolupracovníky.',
  },
  projectPlan: {
    save: 'Uložit plán projektu',
    saveTitle: 'Uložit',
    planSaved: 'Plán projektu uložen',
    planNoteUpdated: 'Poznámka k projektu aktualizována',
    salesNoteNeedsToBeUpdated: 'Poznámka obchodu musí být aktualizována',
    salesManagerNotSet: 'Sales manager nenastaven',
    salesManagerTooltip: 'Sales manager: {name}',
    projectCoordinatorTooltip: 'Project coordinator: {name}',
    salesManagerShort: 'SM:',
    projectCoordinatorShort: 'PC:',
    projectLeadShort: 'PL:',
    projectLeadTooltip: 'Project lead: {name}',
    legendTooltipTitle: 'Význam barev:',
    legendOrange: 'Oranžová: poslední objednávka končí za méně než 30 dní',
    legendRed: 'Červená (po najetí na Link): objednávka už skončila',
    legendGreen: 'Zelená (po najetí na Link): objednávka čeká na začátek',
    legendDefault: 'Bíla / výchozí: objednávka aktuálně běží',
    legendBriefOrange: 'končí <30 dní',
    legendBriefRed: 'skončila',
    legendBriefGreen: 'čeká',
    legendBriefRunning: 'běží',
    updatedBySomeoneElse: 'Data byla aktualizována někým jiným, prosím obnovte stránku.',
    table: {
      occupancy: {
        label: 'Obsazenost',
        billable: 'Fakturovatelné',
        billableTooltipValues: '({totalBillable} / {totalAvailableCapacity}) * 100 = {percentageResult}',
        billableTooltipDescription: '(∑ fakturovatelná plánovaná práce / ∑ dostupná kapacita spolupracovníků) * 100',
        planned: 'Plánováno',
        plannedTooltipValues: '({totalPlanned} / {totalAvailableCapacity}) * 100 = {percentageResult}',
        plannedTooltipDescription: '(∑ veškerá plánovaná práce / ∑ dostupná kapacita spolupracovníků) * 100',
        availableCapacity: 'MD zbývá ',
      },
      project: {
        label: 'Projekt',
        requiredCapacity: 'Požadovaná kapacita',
        requiredCapacityAbbreviation: 'Pož. kap.',
        projectHasNoOrderForThisMonth: 'Projekt nemá pro tento měsíc žádnou objednávku',
        projectOrderHaveNotClientSignDateForThisMonth: 'Některé objednávky projektu nemají datum podpisu klienta',
        orderEndingSoon: 'Poslední objednávka končí za {days} dní',
        orderValidity: 'Platnost: {from} – {to}',
        orderNextValidity: 'Navazující: {from} – {to}',
        orderGap: 'Mezera: {days} dní',
        orderState: {
          running: 'Objednávka běží',
          ended: 'Objednávka skončila',
          upcoming: 'Objednávka čeká na začátek',
          none: 'Bez objednávky',
        },
        totalCapacityTooltip: '∑ {total} MD',
        percentageCapacityTooltip: '{perc}% ({required}/{total})',
        orderLink: 'Objednávky',
        categories: {
          INTERNAL: 'Interní projekt',
          OUTSOURCE: 'Outsource projekt',
          INHOUSE: 'In-house projekt',
        },
      },
      collaborator: {
        label: 'Spolupracovník',
        position: 'Pozice',
        availableCapacity: 'Dostupná kapacita',
        categories: {
          INTERNAL_EMPLOYEE: 'Interní spolupracovník',
          EXTERNAL_EMPLOYEE: 'Externí spolupracovník',
        },
      },
      unusedCapacity: {
        label: 'Nevužitá kapacita',
      },
      internalLabel: 'Interní projekt',
      manager: 'Manažer',
    },
    help: {
      projectItems: 'Tabulka zobrazuje projekty, které jsou aktivní.',
      collaboratorItems: 'Tabulka zobrazuje spolupracovníky, kteří jsou zahrnuti do plánování projektu dle své pozice.',
      overCapacity: 'Kapacita může překročit limit, např.: spolupracovník pracoval přesčas.',
    },
    noSkillsInfo: 'Žádné dovednosti nevyplněny',
    datePicker: 'Měsíc plánu projektu',
    sendNotification: 'Odeslat upozornění',
  },
  operatingCost: {
    sumLabel: 'SUMA:',
    totalCostsPerHourLabel: 'Celkové náklady na hodinu:',
    workHours: 'Pracovní hodiny:',
    editHours: 'Upravit',
    deleteItem: 'Smazat položku',
    datePickerLabel: 'Měsíc provozních nákladů',
    items: 'Položky',
    table: {
      name: 'Název nákladu',
      value: 'Hodnota',
    },
    itemCreated: 'Položka vytvořena',
    itemUpdated: 'Položka aktualizována',
    itemDeleted: 'Položka smazána',
    itemsCopied: 'Položky zkopírovány',
    copy: 'Kopírovat',
    copyTooltip: 'Kopírovat vše z minulého měsíce',
    copyDialog: {
      title: 'Opravdu chcete kopírovat?',
      text: 'Vybraný měsíc bude nahrazen položkami z minulého měsíce.',
    },
    help: {
      copy: 'Kopírování z minulého měsíce nahradí položky aktuálního měsíce.',
      update: 'Položka bude automaticky aktualizována po opuštění polí.',
      create: 'Po vyplnění všech polí lze položku vytvořit stisknutím klávesy Enter.',
    },
  },
  costsPlanning: {
    plannedCostPerWorkHours: 'Prům. plánovaná cena za odpracovanou hod.',
    plannedWorkHours: 'Plánované pracovní hodiny',
    datePicker: 'Rok',
    save: 'Uložit',
    import: 'Importovat',
    exportCsv: 'Exportovat CSV',
    categoryName: 'Název kategorie',
    subCategoryName: 'Název podkategorie',
    yearSum: 'Roční součet',
    sumOfMonth: 'Plánované náklady za měsíc',
    costPlanSaved: 'Nákladový plán uložen',
    cannotSaveCostPlan: 'Nelze uložit nákladový plán. Zkuste to prosím později',
    unsavedChangesAlert: 'Neuložené změny',
    importDialog: {
      title: 'Importovat náklady',
      spreadsheetUrl: 'URL tabulky',
      sheetName: 'Název listu',
      importMonths: 'Vybrané měsíce',
      previewImport: 'Náhled importu',
      executeImport: 'Provést import',
      getImportError: 'Import z Google tabulky se nezdařil',
      saveImportedDataError: 'Uložení importovaných dat se nezdařilo',
      saveImportedDataSuccess: 'Uložení importovaných dat proběhlo úspěšně',
      hideErrors: 'Skrýt chyby',
      showErrors: 'Zobrazit chyby',
      all: 'Vše',
      unmatchedExistingData: 'Nespárované podkategorie existujících dat',
      unmatchedImportedData: 'Nespárované podkategorie importovaných dat - BLOKUJE IMPORT',
    },
  },
  companyProfit: {
    category: {
      name: 'Kategorie nákladu',
    },
    getListError: 'Nelze načíst seznam zisku společnosti',
    noNonEmptyCostSubCategories: 'Pro nákladovou kategorii neexistují žádné neprázdné podkategorie nákladů: ',
    countInCompanyProfit: 'Počítat do zisku',
    notCountInCompanyProfit: 'Nepočítat do zisku',
    includedInCompanyProfit: 'Zahrnuté v zisku',
    investmentCostsDiff: '∑ Rozdíl nákladů',
    costsBalance: '∑ Reálné náklady',
    totalPlannedCost: '∑ Plánované náklady',
    plannedCost: 'Plánované náklady',
    realCost: 'Reálné náklady',
    realCostTooltip: 'Suma dle bankovních transakcí',
    realCostIncludedInCompanyProfit: 'Reálné náklady zahrnuté v zisku',
    correction: 'Korekce nákladů',
    correctionIncludedInCompanyProfit: 'Korekce nákladů zahrnuté v zisku',
    correctionTooltip: 'Pozitivní hodnota znamená větší náklady, negativní znamená menší náklady',
    costDiff: 'Rozdíl nákladů',
    datePickerLabel: 'Měsíc zisku společnosti',
    companyProfit: 'Zisk společnosti',
    cumulativeCompanyProfit: 'Kumulativní zisk společnosti',
    projectsProfit: '∑ Zisk projektů',
    invoiceRevenues: '∑ Fakturované výnosy',
    projectsRevenues: 'Výnosy',
    notCategorizedAmount: 'Nekategorizované náklady',
    profitCorrection: '∑ Korekce (BEZ kategorie nákladu)',
    noteCorrection: 'Poznámka a korekce',
    virtualCorrection: 'Vypočtená korekce pro rozdělení transakce',
    help: {
      projectsProfit: 'Suma zisků všech projektů',
      totalPlannedCost: 'Suma plánovanách nákladů',
      companyProfit: 'Zisk společnosti',
      totalCosts: 'Suma nákladů počítaných do kalkulace, dle bankovních transakcí',
      investmentCostsDiff:
        'Rozdíl mezi plánovanými a reálnými náklady, minusová hodnota znamená, že jsme utratili méně, plusová, že jsme utratili více, než bylo v plánu. Včetně korekcí s cost category',
      countProjectsProfits:
        'Výnos = ∑(plánované náklady) - ∑(skutečné náklady) + ∑(korekce VČETNĚ kategorie nákladů) + ∑(zisky projektu) + ∑(korekce BEZ kategorie nákladů)',
      countInvoiceRevenues:
        'Výnos = - ∑(skutečné náklady) + ∑(korekce VČETNĚ kategorie nákladů) + ∑(fakturované výnosy) + ∑(korekce BEZ kategorie nákladů)',
      sumCorrectionsWithCostCategory:
        'Součet korekcí s kategorií, jak těch manuálně zadaných, tak splity bankovních transakcí',
      sumCorrectionsWithoutCostCategory: 'Součet korekcí bez kategorií nákladů',
      sumProjectRevenues: 'Suma příjmů na projektech, zadaných v kalkulacích projektů',
      invoiceRevenues:
        'Suma fakturovaných částek v daném měsící dle DUZP bez DPH. EUR faktury jsou přepočítány dle kurzu ČNB pro daný den',
    },
    sumCorrectionsWithCostCategory: '∑ Korekce (S kategorií nákladu)',
    costs: 'Náklady',
    revenues: 'Výnosy',
    sumProjectRevenues: '∑ Výnosy projektů',
    profit: 'Zisk',
    profitModel: 'Model zisku',
    companyProfitNoteDialog: {
      value: 'Částka',
      actions: 'Akce',
      bankTransactionSplitInfo: 'Korekce pro bankovní transakci: {id}',
    },
    bankTransactionsDialog: {
      name: 'Bankovní transakce',
      filterByCategory: 'Filtr dle kategorie',
      allCategories: 'Vše',
    },
    correctionsDialog: {
      header: 'Korekce',
      name: 'Název',
      value: 'Částka',
      category: 'Kategorie',
    },
    countProjectsProfits: 'Zisky PROJEKTŮ',
    countInvoiceRevenues: 'Příjmy z FAKTUR',
    count: 'Počet',
    profits: 'Zisky',
  },
  projectCalculation: {
    ftfp: 'FTFP',
    ftfpOrders: 'FTFP objednávky',
    ftfpRevenueTooltip: 'Fixní cena (FTFP) – řádek je generován automaticky a nelze jej upravovat.',
    ftfpAmountForMonth: 'Částka pro {month}',
    ftfpTotalPrice: 'Celkem',
    ftfpRemaining: 'Zbývá',
    ftfpAmountExceedsRemaining: 'Součet by přesáhl cenu objednávky, zbývá maximálně {max} Kč',
    ftfpReduceFirstMonthFirst:
      'Objednávka „{description}“ má celou částku zatím v měsíci {month}. Nejdříve ji tam snižte, ' +
      'teprve pak lze část rozepsat do tohoto měsíce.',
    ftfpReduceFirstMonthFirstError: 'Nejdříve snižte částku v měsíci {month} – zbývá 0 Kč k rozdělení.',
    ftfpRateUnavailable: 'Pro {currency} není k datu {date} dostupný kurz. Zkuste to později.',
    ftfpFutureMonthNotAllocatable:
      'Objednávku v {currency} nelze alokovat do budoucího měsíce – kurz zatím neexistuje.',
    validity: 'Platnost',
    totalBilledFtfpTooltip: 'Do Total billed se započítávají pouze T&M řádky.',
    edit: 'Upravit projekt',
    timeCorrection: 'Korekce času [h]',
    selectedProject: 'Vybrat projekt',
    costs: 'Náklady z výkazů',
    additionalCosts: 'Dodatečné náklady',
    revenues: 'Výnosy',
    profitCZK: 'Hrubý zisk',
    grossProfitTooltip:
      'Hrubý zisk bez započítání překročení rozpočtového plánu, korekce na neobsazenost, tvorbu rezerv a podobně.',
    profitPercent: 'Hrubý zisk %',
    discountCZK: 'Sleva Kč',
    month: 'Vybrat měsíc',
    projectRevenues: 'Výnosy projektu',
    workType: 'Typ práce',
    description: 'Popis',
    pricePerHour: 'Cena za hodinu',
    workedTime: 'Odpracované hodiny',
    ticketKey: 'Klíč',
    ticketTitle: 'Název',
    timeSpendInHours: 'Strávený čas [h]',
    workedHoursSum: 'Odpracováno celkem [h]',
    costPerHour: 'Náklad na hodinu',
    totalCollaboratorCost: 'Celkové náklady',
    calculationUpdated: 'Kalkulace aktualizována',
    revenueSaved: 'Výnos uložen',
    revenueDeleted: 'Výnos smazán',
    noWorkLogs: 'Žádné výkazy práce',
    totalWorked: 'Celkem odpracováno',
    totalWorkedShort: 'Celkem odprac.',
    totalBilled: 'Celkem fakturováno',
    totalWorkedWithCorrection: 'Celkem odpracováno s korekcí',
    totalWorkedWithCorrectionShort: 'Celk. odpr. s kor.',
    moveTicketToProject: 'Přesunout ticket do projektu',
    searchProject: 'Hledat projekt...',
    noProjectsFound: 'Žádné projekty nenalezeny',
    ticketMoved: 'Ticket přesunut',
    from: 'z:',
    to: 'do:',
    setOriginalProject: 'Nastavit původní projekt',
    reportSend: 'Výkaz odeslán',
    reportApproved: 'Výkaz schválen',
    invoiceSent: 'Faktura odeslána',
    billingStatus: 'Stav fakturace',
    projectManager: 'Projektový manažer',
    noProjectManager: 'Žádný projektový manažer',
    projectCoordinator: 'Projektový koordinátor',
    noProjectCoordinator: 'Žádný projektový koordinátor',
    projectLead: 'Vedoucí projektu',
    noProjectLead: 'Žádný vedoucí projektu',
    note: 'Poznámka',
    locked: 'Uzamčeno',
    notCountThisTicketInCalculation: 'Nepočítat tento ticket do kalkulace',
    countThisTicketInCalculation: 'Počítat tento ticket do kalkulace',
    price: 'Cena',
    priceTooltip: 'Cena bez DPH',
    total: 'Celkem',
    copyToClipboardWithoutWorkType: 'Zkopírovat do schránky bez typu práce',
    deleteThisRevenue: 'Smazat tento výnos',
    createNewRevenue: 'Vytvořit nový výnos',
    generateReport: 'Vygenerovat výkaz',
    copyRevenuesFromLastMonth: 'Zkopírovat výnosy z minulého měsíce',
    revenuesCopied: 'Výnosy zkopírovány',
    noRevenuesToCopy: 'Žádné výnosy ke zkopírování z minulého měsíce',
    projectCalculationLocked: 'Kalkulace projektu je uzamčena',
    workLogs: 'Detail výkazů práce pro projekt {projectName}, uživatel {collaboratorName} dne {selectedDate}',
    workLogsDialog: {
      date: 'Datum',
      spentTime: 'Vykázaný čas',
      ticket: 'Ticket',
      summary: 'Popis',
      collaborator: 'Spolupracovník',
    },
    save: 'Uložit změny',
    recordUnsavedChanges: 'Tento záznam má neuložené změny',
    sectionUnsavedChanges: 'Tato sekce má neuložené změny',
    revenuesSaved: 'Změny ve výnosech projektu uloženy',
    totalCollaboratorCostDetailed: 'Celkové náklady na spolupracovníka',
    cannotCreateRevenue: 'Nelze vytvořit výnos: {errors}',
    dataCannotBeSaved: 'Data nelze uložit. Obsahují chyby: {errors}',
    collaboratorRates: 'Sazby spolupracovníků',
    collaborator: 'Spolupracovník',
    diff: 'Rozdíl',
    noOrdersFound: 'Pro vybraný projekt a měsíc nebyly nalezeny žádné prodejní objednávky',
    noCollaborators: 'Nebyli nalezeni žádní spolupracovníci',
    maxHoursExceeded: 'Maximálně {max} hodin povoleno',
    ratesLoadError: 'Sazby se nepodařilo načíst',
    ratesSaveError: 'Sazby se nepodařilo uložit',
    ratesSaveSuccess: 'Sazby byly úspěšně uloženy',
    pricePerMdFormat: '{price}/MD',
    orders: 'Objednávky',
    collaboratorWorkedHours: 'Odpracované hodiny spolupracovníků',
    dateRange: '{from} — {to}',
    pricePerMd: 'Cena za MD',
    addWorkType: 'Přidat typ práce',
    selectWorkType: 'Vyberte typ práce',
    hours: 'Hodiny',
    removeWorkType: 'Odebrat sloupec typu práce',
  },
  projectOverallCalculation: {
    getListError: 'Nelze načíst seznam projektů',
    showZeroProfitProjects: 'Zobrazit projekty s nulovým ziskem',
    type: 'Typ',
    category: 'Kategorie',
    averageProfit: 'Průměrný zisk projektů',
    filterDateMonth: 'Měsíc',
    costs: 'Náklady Kč',
    revenues: 'Výnosy Kč',
    profit: 'Zisk Kč',
    profitInPercentage: 'Zisk %',
    sumProfit: 'Σ zisk:',
    sumWorkedTime: 'Σ odpracovaný čas:',
    sumRevenues: 'Σ výnosy:',
    workedTimeInSec: 'Odpracované hodiny',
    billedTimeInSec: 'Fakturované hodiny',
    billingStatus: 'Stav fakturace',
    projectManager: {
      name: 'Projektový manažer',
    },
    projectCoordinator: {
      name: 'Projektový koordinátor',
    },
    salesManager: {
      name: 'Obchodní manažer',
    },
    locked: 'Uzamčeno',
    calculations: 'Kalkulace',
  },
  salesProjectsStatistics: {
    sumRevenues: 'SUMA výnosů:',
    filterDateMonth: 'Měsíc',
    revenues: 'Výnosy',
    clientName: 'Jméno klienta',
    reportSent: 'Report odeslán',
    showZeroProfitProjects: 'Zobrazit projekty s nulovým ziskem',
  },
  hour: 'Hod',
  hours: 'hodin',
  help: 'Nápověda',
  name: 'Jméno',
  description: 'Popis',
  actions: 'Akce',
  firstName: 'Jméno',
  lastName: 'Příjmení',
  email: 'E-mail',
  password: 'Heslo', // eslint-disable-line sonarjs/no-hardcoded-passwords
  userGroup: 'Uživatelská skupina',
  role: 'Role',
  icon: 'Ikona',
  home: 'Domů',
  logout: 'Odhlásit se',
  openInNewWindow: 'Otevřít v novém okně',
  loginWithGoogle: 'Přihlásit se přes Google',
  login: 'PŘIHLÁSIT SE',
  loginError: 'Chyba přihlášení - zkontrolujte prosím přihlašovací údaje',
  order: 'Pořadí',
  pickIconFrom_url_: 'Vyberte ikonu z {0}.',
  link: 'Odkaz',
  category: 'Kategorie',
  canView: 'Může zobrazit',
  canEdit: 'Může upravovat',
  dataWillBeSynchronizedFromGoogleAfterFirstLogin:
    'Jméno, příjmení a avatar budou synchronizovány z Google po prvním přihlášení',
  token: 'Token',
  projectsList: 'Projekty',
  amount: 'Částka',
  type: 'Typ',
  comment: 'Komentář',
  author: 'Autor',
  currency: 'Měna',
  czk: 'Kč',
  sync: 'Synchronizovat',
  dash: '-',
  permissions: 'Uživatelská oprávnění',
  dateRange: 'Rozsah dat',
  textEditor: {
    bold: 'Tučně',
    italic: 'Kurzíva',
    strike: 'Přeškrtnutí',
    underline: 'Podtržení',
    code: 'Kód',
    paragraph: 'Odstavec',
    heading1: 'Nadpis 1',
    heading2: 'Nadpis 2',
    heading3: 'Nadpis 3',
    bulletList: 'Odrážkový seznam',
    orderList: 'Číslovaný seznam',
    codeBlock: 'Blok kódu',
    horizontalRule: 'Vodorovná čára',
    undo: 'Zpět',
    redo: 'Vpřed',
  },
  organization: {
    name: 'Název organizace',
    url: 'URL organizace',
    create: 'Vytvořit novou organizaci',
    delete: 'Smazat organizaci',
    edit: 'Upravit organizaci',
    active: 'Aktivní',
    managed: 'Spravováno',
    search: 'Hledat organizace',
    saveSuccess: 'Organizace uložena',
    deleteSuccess: 'Organizace smazána',
    deleteOrganization: 'Smazat organizaci',
    organizationExistsError: 'Organizace s tímto názvem, kódem nebo URL již existuje',
    crmLink: 'Odkaz do CRM',
    projects: 'Projekty',
    code: 'Kód',
    organizationIsManaged: 'Organizace je spravována',
    id: 'ID organizace',
    uuid: 'UUID organizace',
    supplier: 'Dodavatel',
    customer: 'Zákazník',
    identificationNumber: 'IČO',
  },
  collaborator: {
    personalSection: 'Osobní',
    companySection: 'Firemní',
    profileSection: 'Profil',
    positions: 'Pozice',
    collaborators: 'Spolupracovníci',
    collaboratorProfile: 'Profil spolupracovníka',
    create: 'Vytvořit nového spolupracovníka',
    search: 'Hledat spolupracovníka',
    positionSelect: 'Vybrat pozice',
    edit: 'Upravit spolupracovníka',
    firstName: 'Jméno',
    warningsCol: 'Upozornění',
    lastName: 'Příjmení',
    generatedId: 'ID',
    uuid: 'UUID',
    privateEmail: 'Soukromý e-mail',
    workEmail: 'Pracovní e-mail',
    hrNotes: 'HR poznámky',
    insuranceCompany: 'Pojišťovna',
    contactPersonPhone: 'Kontaktní osoba jméno + telefon',
    companyIdentificationNumber: 'IČO',
    contactsAddress: 'Kontaktní adresa',
    phone: 'Telefon',
    birthdate: 'Datum narození',
    permanentResidence: 'Trvalé bydliště / Sídlo podnikání',
    personalIdentificationNumber: 'Rodné číslo',
    education: 'Vzdělání',
    profileUrlUpdatedAt: 'Poslední aktualizace URL profilu',
    updatedByAndWhen: 'Aktualizováno {date} uživatelem {collaborator}',
    needsToBeUpdated: 'Profil vyžaduje aktualizaci, poslední změna je starší než 3 měsíce',
    profileDoesntExist: 'Profil spolupracovníka neexistuje',
    confirmProfileUpToDate: {
      title: 'Profil spolupracovníka je zastaralý',
      confirm: 'Označit profil jako aktuální',
      success: 'Profil označen jako aktuální',
    },
    position: {
      name: 'Pozice',
    },
    organization: {
      name: 'Organizace',
    },
    legalType: 'Druh smlouvy',
    BOZP: 'BOZP',
    bankAccountNumber: 'Číslo bankovního účtu',
    workStart: 'Začátek spolupráce',
    workEnd: 'Konec spolupráce',
    jiraId: 'Jira ID',
    organizations: 'Organizace',
    lookingForCollaborators: 'Hledání spolupracovníků...',
    noCollaboratorYet: 'Zatím žádní spolupracovníci.',
    saveSuccess: 'Spolupracovník uložen',
    saveSkillsSuccess: 'Dovednosti spolupracovníka uloženy',
    deleteSuccess: 'Spolupracovník smazán',
    deleteFailed: 'Smazání spolupracovníka se nezdařilo',
    editCollaboratorSkills: 'Upravit dovednosti spolupracovníka',
    removeCollaboratorSkill: 'Odstranit dovednost spolupracovníka',
    addCollaboratorSkill: 'Přidat dovednost spolupracovníka',
    editCollaborator: 'Upravit spolupracovníka',
    deleteCollaborator: 'Smazat spolupracovníka',
    userIdentities: 'Uživatelské identity (ticket systémy)',
    collaboratorSkillSlider: {
      min: '5 je nejhorší',
      max: '1 je nejlepší',
    },
    noSkillFound: 'Pro spolupracovníka nebyla nalezena žádná dovednost s hodnotou 1 až 4',
    assets: 'Majetek spolupracovníka',
    fullName: 'Celé jméno',
    profileUrl: 'URL profilu',
    activeCollaborators: 'Aktivní spolupracovníci',
    active: 'Aktivní',
    leavingChecklist: 'Výstupní list',
    warnings: {
      title: 'Upozornění',
      shouldHaveBozp: 'Chybí evidence BOZP',
      shouldHaveBaseWorkingDaysCountForCurrentMonth: 'Není nastaven fond pracovní doby pro aktuální měsíc',
      shouldHaveCostForCurrentMonth: 'Nejsou zadány náklady pro aktuální měsíc',
      hasUndoneLeavingChecklistItems: 'Nevyřízené položky výstupního listu',
      isActiveButHasWorkEndInThePast: 'Spolupráce ukončena, ale profil je stále aktivní',
      shouldHaveMatchingLegalType: 'Nesoulad v typu právního vztahu pro aktuální měsíc',
    },
    type: 'Typ',
    types: {
      INTERNAL: 'Interní',
      EXTERNAL: 'Externí',
    },
    generateLeavingChecklist: 'Vygenerovat výstupní list',
    leavingChecklistDialog: {
      title: 'Vygenerovat výstupní list',
      text: 'Opravdu chcete resetovat aktuální výstupní list?',
    },
    responsiblePerson: 'Odpovědná osoba',
    markSkillsUpToDateSuccess: 'Dovednosti byly úspěšně označeny jako aktuální',
    requiredFields: 'Povinná pole jsou označena: ',
    activeTooltip: `Dopady deaktivace spolupracovníka:
------------------------------------------------------
  ERP
- Vyřazuje neaktivní collaboratory z pracovních plánů
- Nezobrazuje varování o chybějících nákladech u neaktivních uživatelů
- Filtruje neaktivní collaboratory v collaborator listu
- Bude zobrazovat warningy u neaktivních collaboratorů, kteří nemají splněný výstupní checklist

HUB
- The Game: zabraňuje udělování experience bodů neaktivním collaboratorům
- Slack integrace: ignoruje při týdenním zasílání feedbacku, vynechává při aktualizaci avatarů
- Feedback systém: neaktivní uživatelé nejsou zahrnuti do feedback heat mapy ani do poznámek
  `,
    collaboratorIdentities: 'Identity v ticketovacích systémech',
    externalId: 'Externí ID',
    externalIdsUpdated: 'Externí ID byla aktualizována',
    skillsNotice: 'Dovednosti (vyjma hodnoty 5)',
  },
  collaboratorNotes: {
    editCollaboratorNotes: 'Upravit poznámky ke spolupracovníkovi',
    enterYourNote: 'Zadejte svou poznámku ...',
    deleteSuccess: 'Poznámka smazána',
    saveSuccess: 'Poznámka uložena',
    buttons: {
      addNote: 'Přidat poznámku',
    },
  },
  project: {
    name: 'Název projektu',
    status: 'Stav projektu',
    abbreviation: 'Zkratka projektu',
    category: 'Kategorie',
    type: 'Typ',
    organization: {
      name: 'Název organizace',
    },
    uuid: 'Uuid',
    projectInfo: 'Informace o projektu',
    projectTools: 'Nástroje projektu',
    paidActivities: 'Placené aktivity',
    techFides: 'TechFides',
    client: 'Klient',
    billing: 'Fakturace',
    projectManager: {
      name: 'Projektový manažer',
    },
    projectCoordinator: {
      name: 'Projektový koordinátor',
    },
    projectLead: {
      name: 'Vedoucí projektu',
      tooltip:
        'Project leaderem může být pouze ten, kdo splňuje alespoň mediorní úroveň v leaderovi v rámci standardů DBG',
    },
    salesManager: {
      name: 'Obchodní manažer',
    },
    responsibleManager: 'Zodpovědný manažer',
    billingData: 'Fakturační údaje (adresa, IČ atd.)',
    billingInfo: 'Fakturační informace (poznámky)',
    billingEmails: 'Fakturační e-maily',
    billingParameters: 'Fakturační parametry',
    reporting: {
      heading: 'Reporting',
      monthly: 'Měsíční',
      weekly: 'Týdenní',
    },
    plannedHours: 'Plánované hodiny',
    dueInDays: 'Splatnost ve dnech',
    firstReminder: 'První upomínka',
    nextReminder: 'Další upomínka',
    internal: 'Interní',
    external: 'Externí',
    inHouse: 'In-house',
    outsource: 'Outsource',
    active: 'Aktivní',
    search: 'Hledat projekty',
    create: 'Vytvořit nový projekt',
    edit: 'Upravit projekt',
    delete: 'Smazat projekt',
    crmLink: 'Odkaz do CRM',
    devLead: 'Dev lead',
    section: {
      projectInfo: 'Informace o projektu',
      roles: 'Role',
      billing: 'Fakturace',
      settings: 'Nastavení',
    },
    projectMainGoal: 'Hlavní cíl',
    projectMainRisks: 'Hlavní rizika',
    analysisPaid: 'Analýza',
    developPaid: 'Vývoj',
    testingPaid: 'Testování',
    projectManagementPaid: 'Projektové řízení',
    collaborationType: 'Typ spolupráce',
    ticketSystem: 'Ticketovací systém',
    gitRepository: 'GIT repozitář',
    communicationTools: 'Komunikační nástroje',
    documentationLink: 'Odkaz na dokumentaci',
    otherProjectNotes: 'Poznámky',
    collaborationTypeItem: {
      TIME_AND_MATERIAL: 'Time & Material',
      FIX_PRICE: 'Fix price',
    },
    noteForThisMonth: 'Poznámka pro tento měsíc',
    saveSuccess: 'Projekt uložen',
    orders: 'Objednávky',
    invoices: 'Faktury',
    contacts: 'Kontakty',
    deleteProject: 'Smazat projekt',
    deleteSuccess: 'Projekt smazán',
    areYouSureToDelete: 'Opravdu chcete smazat tento projekt?',
    noProjects: 'Buď nemáte žádné projekty, nebo nemáte dostatečná oprávnění k jejich zobrazení',
    projectIdentities: 'Identity projektu',
    externalId: 'Externí ID',
    externalIdsUpdated: 'Externí ID projektu byla úspěšně aktualizována',
    failedToLoadProjectIdentities: 'Nepodařilo se načíst identity projektu',
  },
  projectContacts: {
    name: 'Jméno',
    phone: 'Telefon',
    email: 'Email',
    position: 'Pozice',
    notes: 'Poznámky',
    contactCreated: 'Kontakt vytvořen',
    contactUpdated: 'Kontakt aktualizován',
    contactDeleted: 'Kontakt smazán',
  },
  invoice: {
    search: 'Hledat faktury',
    create: 'Vytvořit novou fakturu',
    edit: 'Upravit fakturu',
    delete: 'Smazat fakturu',
    view: 'Zobrazit fakturu',
    taxPointDate: 'Datum zdanitelného plnění',
    taxPointDateMonth: 'Měsíc data zdanitelného plnění',
    dateCreated: 'Datum vystavení',
    dateOfPayment: 'Datum splatnosti',
    dueDate: 'Datum splatnosti',
    variableSymbol: 'Variabilní symbol',
    datePaid: 'Datum úhrady',
    priceWithoutVat: 'Cena (bez DPH)',
    currency: 'Měna',
    vatPercent: 'DPH (%)',
    vatAmount: 'DPH',
    invoiceNumber: 'Číslo faktury',
    counterpartyName: 'Dodavatel',
    counterpartyCIN: 'IČO',
    bankAccount: 'Bankovní účet',
    direction: 'Směr',
    directions: {
      sales: 'Vydané',
      purchase: 'Přijaté',
    },
    premierVersion: 'Verze Premier',
    project: {
      name: 'Projekt',
    },
    confirm: 'Potvrdit',
    cancel: 'Zrušit',
    saveSuccess: 'Faktura uložena',
    expectedAmount: 'Očekávaná částka',
    note: 'Poznámka',
    invoiceStatus: 'Stav',
    status: {
      PAID: 'Zaplaceno',
      CURRENT: 'Před splatností',
      PAST_DUE: 'Po splatnosti',
    },
    order: 'Objednávka',
    organization: 'Organizace',
    type: 'Typ',
    types: {
      STANDARD: 'Standardní',
      PROFORMA: 'Zálohová',
    },
    proformaInvoices: 'Zálohové faktury',
    files: 'Soubory',
    fileNames: 'Soubory',
    fileUploadError: 'Nelze uložit soubory',
    maxFileErrorMessage: 'Nelze přidat více než 10 souborů',
    maxFileSizeErrorMessage: 'Maximální velikost souboru je 30 MB',
    dropText: 'Přetáhněte soubory sem',
    thisInvoice: 'tuto fakturu',
  },
  all: 'Vše',
  noDataForSelectedDate: 'Žádná data pro zvolené období',
  noDataForSelectedFilter: 'Žádná data pro zvolený filtr',
  showInChart: 'Zobrazit v grafu',
  yes: 'ano',
  no: 'ne',
  searching: 'Vyhledávání...',
  noData: 'Nebyla nalezena žádná data',
  clearFilter: 'Vymazat filtr',
  deleteDialog: {
    title: 'Smazat',
    text: 'Opravdu chcete smazat',
    delete: 'Smazat',
  },
  navigateAwayDialog: {
    title: 'Opravdu chcete odejít?',
    text: 'Veškeré neuložené změny budou ztraceny.',
  },
  personalSettings: {
    tables: 'Tabulky',
    table: {
      itemsPerPage: 'Položek na stránku',
    },
  },
  percent: '%',
  md: 'MD',
  h: 'h',
  mdAvgMo: 'MD prům ({monthsCount}měs) | MD prům ({monthsCount}měs) | MD prům ({monthsCount}měs)',
  hAvgMo: 'h prům ({monthsCount}měs) | h prům ({monthsCount}měs) | h prům ({monthsCount}měs)',
  darkMode: 'Tmavý režim',
  month: 'Měsíc',
  monthName: 'Leden | Únor | Březen | Duben | Květen | Červen | Červenec | Srpen | Září | Říjen | Listopad | Prosinec',
  year: 'Rok',
  updated: 'Aktualizováno',
  orders: {
    description: 'Popis',
    fixedPrice: 'Cena',
    priceMustBePositive: 'Cena musí být kladné číslo',
    currencyRequired: 'Měna je povinná',
    id: 'ID',
    timeProgress: 'Časový průběh',
    setFilterToActive: 'Zobrazit aktivní',
    search: 'Hledat objednávky',
    create: 'Vytvořit novou objednávku',
    edit: 'Upravit objednávku',
    delete: 'Smazat objednávku',
    view: 'Zobrazit objednávku',
    validFrom: 'Platné od',
    validTo: 'Platné do',
    requestedCapacityFte: 'Požadovaná kapacita [FTE]',
    confirmType: 'Typ potvrzení',
    projectName: 'Projekt',
    state: 'Stav',
    organizationName: 'Organizace',
    stateName: 'Stav',
    validDateIn: 'Platné v',
    validDateError: "'Platné do' musí být větší nebo rovno 'Platné od'",
    orderTypeRequired: 'Objednávka musí být buď prodej nebo nákup',
    orderExistsError: 'Objednávka s tímto číslem již existuje',
    confirm: 'Potvrdit',
    cancel: 'Zrušit',
    saveSuccess: 'Objednávka uložena',
    note: 'Poznámka',
    states: 'Stavy',
    files: 'Soubory',
    fileNames: 'Soubory',
    fileUploadError: 'Nelze uložit soubory',
    maxFileErrorMessage: 'Nelze přidat více než 10 souborů',
    maxFileSizeErrorMessage: 'Maximální velikost souboru je 30 MB',
    projects: 'Projekty',
    dropText: 'Přetáhněte soubory sem',
    workType: 'Typ práce',
    requestedCapacity: 'Požadovaná kapacita',
    capacityFte: 'Kapacita [FTE]',
    price: 'Cena MD',
    currency: 'Měna',
    priceAndCurrencyRequired: 'Cena a měna musí být vyplněny pro typy práce s vyplněným FTE',
    name: 'Název',
    isSale: 'Prodej',
    isPurchase: 'Nákup',
  },
  roadmapTable: {
    project: 'Projekt',
    md: 'MD',
    start: 'Začátek',
    end: 'Konec',
  },
  companyWorkPerformance: {
    workedTimeExternalProjects: 'Odpracovaný čas - externí projekty',
    workedTimeInternalProjects: 'Odpracovaný čas - interní projekty',
    occupancy: 'Vytížení',
    realOccupancy: 'Reálné vytížení',
    occupancyThisMonth: 'Vytížení k 1. dni v měsíci',
    occupancyNextMonth: 'Vytížení k 1. dni příštího měsíce',
    paidInvoicesSum: 'Fakturováno bez DPH',
    averagePrice: 'Průměrná cena',
    averagePriceOverLast3Months:
      'Průměrná cena za poslední {monthsCount} měsíce | Průměrná cena za poslední {monthsCount} měsíců | Průměrná cena za posledních {monthsCount} měsíců',
    help: {
      realOccupancy:
        'Reálné vytížení spočítané jako poměr mezi odpracovanýma hodinama mezi interníma a externíma projektama, dle logů v jiře',
      paidInvoicesSum:
        'Suma fakturovaných částek, dle faktur zaevidovanch v ERP. Nebere se v potaz jejich proplacenost. Pouze INHOUSE projekty, tedy bez OUTSORCE',
      averagePrice: 'Průměrná cena za měsíc, dle fakturovaných částek a odpracovaného času na externích projektech',
    },
  },
  state: {
    name: 'Stát',
  },
  salesRoadmap: {
    rangePickerLabel: 'Vybrat měsíce',
  },
  homePage: {
    greeting: {
      morning: 'Dobré ráno',
      afternoon: 'Dobré odpoledne',
      evening: 'Dobrý večer',
    },
    kpi: {
      invoices: 'Nezaplacené faktury po splatnosti',
      bankTransactions: 'Nekategorizované platby',
      billableNextMonth: 'Fakturovatelnost příštího měsíce',
      worklogAnalysis: 'Problémy ve výkazech',
      collaboratorsInternal: 'Problémy interních spolupracovníků',
      collaboratorsExternal: 'Problémy externích spolupracovníků',
    },
    help: {
      badges: {
        menuItemsBadgesMeaning: 'Význam odznaků v menu:',
        invoices: {
          name: 'Faktury:',
          meaning: 'Počet nezaplacených faktur po splatnosti',
        },
        projectPlan: {
          name: 'Plán projektu spolupracovníka:',
          meaning: 'Vytížení (procento využité kapacity spolupracovníka) pro příští měsíc',
        },
        projectPlanV2: {
          name: 'Plán projektu spolupracovníka:',
          meaning: 'Vytížení (procento využité kapacity spolupracovníka) pro příští měsíc',
        },
        projectCalculation: {
          name: 'Kalkulace projektu:',
          meaning: 'Počet projektů v minulém měsíci s náklady a neodeslaným výkazem',
        },
        bankTransactionsV2: {
          name: 'Bankovní transakce:',
          meaning: 'Počet nekategorizovaných odchozích plateb',
        },
        worklogAnalysis: {
          name: 'Analýza výkazů:',
          meaning: 'Počet nových úkolů ve výkazech',
        },
        collaboratorsInternal: {
          name: 'Interní spolupracovníci:',
          meaning: 'Počet problémů u interních spolupracovníků',
        },
        collaboratorsExternal: {
          name: 'Externí spolupracovníci:',
          meaning: 'Počet problémů u externích spolupracovníků',
        },
      },
    },
  },
  ticketTimeCorrection: {
    ticketTimeCorrection: 'Korekce času ticketu',
    date: 'Datum',
    comment: 'Komentář',
    timeCorrectionInHours: 'Korekce času v hodinách',
    deleteThisCorrection: 'Smazat tuto korekci',
    dateIsRequired: 'Datum je povinné',
    timeCorrectionIsRequired: 'Korekce času je povinná',
    createNewTicketTimeCorrection: 'Vytvořit novou korekci času ticketu',
  },
  collaboratorSalesInfo: {
    mdCzkThisMonth: 'Kč/MD tento měsíc',
    hCzkThisMonth: 'Kč/h tento měsíc',
    mdCzkLastThreeMonths: 'Kč/MD poslední 3 měsíce',
    hCzkLastThreeMonths: 'Kč/h poslední 3 měsíce',
    costs: 'Náklady',
    salesNotes: 'Obchodní poznámky',
    otherSpecialistsAveragesWithSamePosition: 'Průměry ostatních specialistů na stejné pozici',
    collaboratorPriceWarning:
      'Tato cena je nižší nebo rovna (průměrná cena pozice +20%). Pravděpodobně nebudete schopni nahradit tohoto specialistu za aktuální cenu.',
    collaboratorPriceOk: 'Tato cena je vyšší než (průměrná cena pozice +20%).',
  },
  collaboratorCapacityReport: {
    showCollaborators: 'Zobrazit spolupracovníky',
    occupancy: 'Vytížení',
    filter: {
      showingItemOfItems: 'Zobrazeno {visibleItemsCount} z {itemsCount}, aplikovaný filtr:',
      availableCapacity: 'dostupná kapacita >= {capacity}MD',
      skillValue: 'hodnota dovednosti >= {skill}',
      department: 'oddělení = {department}',
      minAvailableCapacity: 'Minimální dostupná kapacita:',
      minSkillValue: 'Minimální hodnota dovednosti:',
    },
    moneyMode: 'Finanční pohled',
    lostRevenue: 'Ušlý příjem',
    unusedCapacity: 'Nevyužitá kapacita: {md} MD',
    czk: 'CZK',
    md: 'MD',
    annualStatusTooltip: {
      title: 'Vytížení v měsíci',
      totals: 'Dostupné: {total} · Využité: {used} · Nevyužité: {unused}',
      calculation: 'Vytížení = využité / dostupné = {used} / {total} = {occupancy}',
      indicatorMatched: 'Vybrán indikátor {icon} (limit ≥ {limit}, vytížení {occupancy})',
      noIndicatorMatched: 'Žádný limit indikátoru nebyl dosažen',
    },
  },
  agGridOptionsSidebar: {
    expandHideRows: 'Rozbalit / skrýt řádky',
    changePagination: 'Počet řádků na stránku',
    savePersonalSettings: 'Uložit nastavení tab.',
    resetColumns: 'Resetovat sloupce',
    columnsSettings: 'Nastavení sloupců',
    export: 'Exportovat',
    downloadCsv: 'Stáhnout CSV',
    downloadExcel: 'Stáhnout EXCEL',
    fixedCols: 'Nastavit sloupce automaticky',
    options: 'Možnosti',
  },
  majorSkills: 'Hlavní dovednosti',
  juniorSkills: 'Junior dovednosti',
  mediorSkills: 'Medior dovednosti',
  seniorSkills: 'Senior dovednosti',
  profileLink: 'Odkaz na profil',
  info: 'Info',
  notes: 'Poznámky',
  id: 'ID',
  skills: 'Dovednosti',
  note: 'Poznámka',
  corrections: 'Korekce',
  fileInput: {
    deleteAllFiles: 'Opravdu chcete smazat všechny soubory',
  },
  cEditableTable: {
    create: 'Vytvořit položku',
    disabled: 'Vstupy jsou neplatné',
  },
  cEditableRowItem: {
    deleteItem: 'Smazat položku',
  },
  checked: 'Zkontrolováno',
  next: 'další',
  prev: 'předchozí',
  accessDenied: 'Přístup zamítnut',
  department: 'Oddělení',
  currentCompany: 'Společnost',
  language: 'Jazyk',
  tooltips: {
    skillHeatmap: {
      skill: 'Dovednost:',
      value: 'Hodnota:',
    },
  },
  personalSettingsPage: {
    personalSettings: 'Osobní nastavení',
    userProfile: 'Uživatelský profil',
    socketEvents: 'Události socketu',
    idToken: 'ID token',
    tabs: {
      language: 'Jazyk',
      debug: 'Debug info',
    },
    languageSettings: 'Nastavení jazyka',
  },
  collaboratorProfilesPage: {
    selectFirst: 'Nejprve vyberte spolupracovníka',
    save: 'Uložit',
    lastEdit: 'Poslední úprava',
    by: 'od',
    skillsOutdatedBannerDays:
      'Nezapomeň zkontrolovat také dovednosti spolupracovníka — poslední úprava byla před {days} dny.',
    skillsOutdatedBannerNever: 'Dovednosti tohoto spolupracovníka ještě nebyly aktualizovány.',
    openSkills: 'Otevřít dovednosti',
    baseInfo: 'Základní info',
    collaboratorId: 'ID spolupracovníka:',
    experience: 'počet let praxe',
    willingnessToLeadTeam: 'ochota vést tým',
    experienceInLeadingTeam: 'zkušenosti s vedením týmu',
    skills: 'Dovednosti',
    other: 'Ostatní',
    projects: 'Projekty',
    strengthsWeaknesses: 'Silné a slabé stránky',
    otherTechnologies: 'Ostatní technologie',
    workedMD: 'odpracováno MD:',
    monthsOnProject: 'měsíců na projektu:',
    certifications: 'Certifikace',
    profileUrl: 'URL profilu',
    designAndArchitecture: {
      softwareArchitecture: 'Návrh architektury softwarových systémů',
      databaseArchitecture: 'Návrh architektury databází',
      technologySelection: 'Výběr vhodných technologií pro projekty',
      technicalLeadership: 'Vedení technických týmů k úspěchu',
    },
    development: {
      frontend: 'Práce na frontendu aplikací',
      backend: 'Práce na backendu aplikací',
      database: 'Správa a údržba databází',
      api: 'Vývoj a údržba API',
    },
    testingAndQA: {
      unitTesting: 'Psaní a spouštění unit testů',
      e2eTesting: 'Provádění end-to-end testování',
      codeReview: 'Kontrola a schvalování změn v kódu',
      bugFixing: 'Oprava chyb a problémů v kódu',
    },
    maintenance: {
      refactoring: 'Vylepšování existujícího kódu pomocí refaktoringu',
      support: 'Poskytování podpory pro systém',
    },
    collaborationAndCommunication: {
      customerCommunication: 'Komunikace se zákazníky a klienty',
      teamCollaboration: 'Spolupráce s týmem',
      documentation: 'Vytváření a aktualizace dokumentace',
    },
    projectManagement: {
      estimationAndPlanning: 'Odhad času a zdrojů pro projekty',
      taskManagement: 'Řízení a přidělování úkolů',
      monitoringAndReporting: 'Sledování pokroku a generování reportů',
    },
  },
  layout: {
    instanceTypeWarning: '⚠️ Toto není produkční instance ⚠️',
    impersonationWarning: '⚠️ Jste přihlášeni jako jiný uživatel ⚠️',
  },
  menu: {
    home: 'Domů',
    settings: 'Nastavení',
    personalSettings: 'Osobní nastavení',
    favorites: 'Oblíbené',
    sales: 'Obchod',
    projects: 'Projekty',
    hr: 'HR',
    finance: 'Finance',
    analysis: 'Analýza',
    planning: 'Plánování',
    organizations: 'Organizace',
    orders: 'Objednávky',
    availableCapacityReport: 'Report volné kapacity',
    ordersRoadmap: 'Roadmapa objednávek',
    salesProjectsStatistics: 'Statistiky výnosů projektů',
    collaboratorProfiles: 'Profily spolupracovníků',
    projectsList: 'Seznam projektů',
    projectCalculation: 'Kalkulace projektu',
    projectOverview: 'Přehled projektu',
    worklogTimesheet: 'Výkaz práce',
    collaboratorsInternal: 'Interní spolupracovníci',
    collaboratorsExternal: 'Externí spolupracovníci',
    collaboratorSkills: 'Dovednosti spolupracovníků',
    bankTransactionsV2: 'Bankovní transakce',
    collaboratorCostsInternal: 'Náklady interních spolupracovníků',
    collaboratorCostsExternal: 'Náklady externích spolupracovníků',
    costsPlanning: 'Plánování nákladů',
    companyProfit: 'Zisk společnosti',
    invoices: 'Faktury',
    assets: 'Majetek',
    projectOverallCalculation: 'Celková kalkulace projektů',
    worklogAnalysis: 'Analýza výkazů práce',
    costsAnalysis: 'Analýza nákladů',
    companyProfitAnalysis: 'Analýza zisku společnosti',
    estimateAnalysis: 'Analýza odhadů',
    collaboratorWorkPlan: 'Pracovní plán spolupracovníků',
    projectPlanV2: 'Projektový plán spolupracovníků',
    collaboratorStats: 'Statistiky spolupracovníků',
    collaboratorProfit: 'Ziskovost spolupracovníků',
    aiChatV2: 'AI Chat',
  },
  menuDescriptions: {
    home: 'Dashboard poskytující komplexní přehled klíčových ukazatelů výkonnosti společnosti, nedávných aktivit a důležitých systémových upozornění.',
    settings: 'Globální konfigurace aplikace, včetně systémových parametrů, správy oprávnění a obecných nastavení.',
    personalSettings:
      'Správa vašeho individuálního uživatelského profilu, preferencí zobrazení, nastavení tabulek a zabezpečení osobního účtu.',
    organizations:
      'Kompletní databáze partnerských organizací, klientů a dodavatelů, včetně kontaktních údajů a souvisejících projektů.',
    orders:
      'Komplexní seznam všech objednávek klientů, sledující jejich životní cyklus od počáteční dohody po dokončení.',
    availableCapacityReport:
      'Vizuální report dostupnosti spolupracovníků napříč společností, umožňující efektivní alokaci zdrojů na základě dovedností a pracovního vytížení.',
    ordersRoadmap:
      'Interaktivní časová osa zobrazující rozložení objednávek v čase, usnadňující dlouhodobé plánování a prognózu kapacit.',
    salesProjectsStatistics:
      'Hloubková finanční analýza obchodně orientovaných projektů, porovnávající výnosy, náklady a celkové marže ziskovosti.',
    collaboratorProfiles:
      'Detailní úložiště odbornosti spolupracovníků, certifikací, historie projektů a záznamů o profesním rozvoji.',
    projectsList:
      'Centrální registr všech interních a externích projektů, poskytující přehled o jejich aktuálním stavu a odpovědných manažerech.',
    projectCalculation:
      'Detailní finanční rozpis konkrétního projektu, včetně podrobných vykázaných nákladů, dodatečných výdajů a sledování výnosů.',
    projectOverview:
      'Detailní dashboard pro jeden projekt, shromažďující základní informace, členy týmu a celkové ukazatele zdraví projektu.',
    worklogTimesheet:
      'Personalizovaný pohled pro záznam a kontrolu denních pracovních aktivit, zajišťující přesné sledování času.',
    collaboratorsInternal:
      'Databáze a rozhraní pro správu interních spolupracovníků pokrývající osobní údaje, pozice a historii ve firmě.',
    collaboratorsExternal:
      'Správa externích partnerů, dodavatelů a freelancerů sledující jejich zapojení a administrativní detaily.',
    collaboratorSkills:
      'Centrální tabulka dovedností a kompetencí napříč týmem používaná pro přiřazování k projektům a identifikaci potřeb školení.',
    bankTransactions: 'Integrovaný pohled na bankovní účty společnosti, umožňující snadnou kategorizaci plateb.',
    collaboratorCostsInternal: 'Detailní analýza nákladů spojených s interními spolupracovníky, včetně mezd a bonusů.',
    collaboratorCostsExternal: 'Sledování a správa nákladů souvisejících s externími dodavateli.',
    costsPlanning:
      'Nástroj pro strategické plánování měsíčních provozních výdajů a dalších nákladů nesouvisejících s projekty.',
    companyProfit:
      'Obecný finanční přehled výkonnosti společnosti konsolidující výnosy a náklady pro zobrazení ziskovosti v reálném čase.',
    invoices:
      'Komplexní správa vystavených a přijatých faktur, včetně sledování plateb, detailů DPH a digitální archivace.',
    assets: 'Systém sledování inventáře firemního hardwaru a dalšího vybavení přiděleného spolupracovníkům.',
    projectOverallCalculation:
      'Konsolidovaný finanční report napříč několika projekty umožňující porovnání mezi projekty a souhrnnou analýzu výkonnosti.',
    worklogAnalysis:
      'Analytický nástroj pro přezkoumání vzorců ve výkazech, identifikaci slabých míst a optimalizaci efektivity týmu.',
    costsAnalysis:
      'Pokročilá vizualizace a rozpad nákladů společnosti podle kategorií, podkategorií a časových období.',
    companyProfitAnalysis:
      'Historická analýza trendů zisku společnosti, poskytující vhled pro dlouhodobé finanční plánování a strategii.',
    collaboratorWorkPlan:
      'Plánovací rozhraní pro definování pracovní dostupnosti spolupracovníků, dovolených a plánované kapacity.',
    collaboratorProjectPlan:
      'Strategický nástroj pro přiřazování spolupracovníků na konkrétní projekty na základě jejich plánované kapacity a požadavků projektu.',
    collaboratorStats:
      'Analytická zpráva poskytující přehled o počtu spolupracovníků, jejich rozdělení do oddělení a historických trendech.',
    collaboratorProfit: 'Přehled zisku generovaného jednotlivými spolupracovníky napříč projekty.',
    googleDocument: '-',
  },
  collaboratorProfit: {
    filterDates: 'Rozsah dat',
    filterUser: 'Spolupracovník',
    all: 'Vše',
    internal: 'Interní',
    external: 'Externí',
    collaborator: 'Spolupracovník',
    type: 'Typ',
    position: 'Pozice',
    workedHours: 'Odpracované hodiny',
    billedHours: 'Billované hodiny',
    unbilledHours: 'Nebillované hodiny',
    totalCosts: 'Celkové náklady',
    totalRevenue: 'Celkové příjmy',
    marginCzk: 'Marže',
    marginPercent: 'Marže',
    project: 'Projekt',
  },
  worklogTimesheet: {
    hello: 'Ahoj světe',
    selectUser: 'Vybrat spolupracovníka',
    selectProject: 'Vybrat projekt',
    collaboratorMode: 'Spolupracovníci',
    projectMode: 'Projekty',
    from: 'Od',
    to: 'Do',
    sum: 'Suma',
    thisWeek: 'Tento týden',
    prevWeek: 'Minulý týden',
    thisMonth: 'Tento měsíc',
    prevMonth: 'Minulý měsíc',
    dateRangeMax6Months: 'Časové rozmezí nesmí převýšit 6 měsíců',
    dateRangeInvalid: "Datum 'Do' musí být stejné nebo větší než datum 'Od'",
  },
  aiChatV2: {
    title: 'AI Chat',
    homeSearchPlaceholder: 'Zeptejte se AI...',
    newConversation: 'Nová konverzace',
    placeholder: 'Napište zprávu…',
    deleteConfirm: 'Smazat tuto konverzaci?',
    delete: 'Smazat',
    sessionActions: 'Možnosti',
    rename: 'Přejmenovat',
    renamePlaceholder: 'Název konverzace',
    reloginRequired: 'Přihlaste se prosím znovu',
    connection: {
      connected: 'Připojeno',
      connecting: 'Připojování…',
      disconnected: 'Odpojeno — kliknutím se připojíte znovu',
    },
    emptySidebar: 'Zatím žádné konverzace',
    loadingSessions: 'Načítání konverzací…',
    thinking: 'Přemýšlím…',
    responding: 'Generuji odpověď…',
    usingTool: 'Používám nástroj:',
    startConversation: 'Začněte novou konverzaci',
    toolCall: 'Volání nástroje',
    toolResult: 'Výsledek nástroje',
    toolError: 'chyba',
    showToolBlocks: 'Zobrazit volání a výsledky nástrojů',
    hideToolBlocks: 'Skrýt volání a výsledky nástrojů',
    settings: 'Nastavení',
    modelLabel: 'Model',
    thinkingLabel: 'Přemýšlení',
    thinkingLevel: 'Úroveň přemýšlení: {level}',
    thinkingLevels: {
      serverDefault: 'Výchozí (server)',
      off: 'Vypnuto',
      low: 'Nízká',
      medium: 'Střední',
      high: 'Vysoká',
    },
    models: {
      serverDefault: 'Výchozí model',
    },
    fullMessage: 'Celá zpráva',
    fullMessagePreview: 'Náhled',
    fullMessageMarkdown: 'Markdown',
    viewFullMessage: 'Zobrazit celou zprávu',
    copyMessage: 'Zkopírovat',
    messageCopied: 'Zkopírováno!',
    prompts: {
      button: 'Uložené prompty',
      title: 'Uložené prompty',
      empty: 'Zatím žádné uložené prompty. Uložte si dotaz, který posíláte opakovaně.',
      noResults: 'Nic nenalezeno.',
      new: 'Nový prompt',
      saveCurrent: 'Uložit aktuální text',
      edit: 'Upravit',
      delete: 'Smazat',
      search: 'Hledat v promptech…',
      dialogTitle: 'Uložený prompt',
      name: 'Název',
      text: 'Text promptu',
      nameTaken: 'Prompt s tímto názvem už máte.',
    },
  },
};
